import Reading from "./reading.page";

export default Reading;
